import React from "react";

import './fcresult.css';

const setPlannedDate = (status, date) => {
    if(status === "Pianificato") return(
        <tr>
            <td style={{fontWeight: 'bold', color: 'rgb(95, 106, 106)'}}>Data</td>
            <td>{date}</td>
        </tr>
    )
}

const FibercopResult = (props) => {
 
    const address = props.address;
    const data = props.data;
    const details = data.FC.details;

    return (
        // Lista dei civici in caso non sia specificato un civico
        (data.FC.details.length > 1) ?
            <div>
                <h3  style={{textAlign: 'center'}}>Civici e scale</h3>
                <ul className="FC_Details" style={{fontSize: '23px', listStyleType: 'none', paddingLeft: '0', maxHeight: '150px', padding: '10px', overflowY: 'scroll'}}>
                    {data.FC.details.map((item, index) => (
                        <li key={index} style={{color: '#a6acaf', width: '95%', display: 'flex', margin: 'auto', marginBottom: '5px', border: '1px solid grey', padding: '2px', paddingInline: '5px'}}>
                            {`${address} ${item.civic}`}
                        </li>
                    ))}
                </ul>
            </div>
         :
            <div className="FC_Details">
                <h2 style={{textAlign: 'center'}}>Dettagli</h2>
                <p className="techtTitle">Generali</p>
                <table style={{border: '1px solid #dee2e6'}} className="dataTable">
                    <tr>
                        <td style={{fontWeight: 'bold', color: 'rgb(95, 106, 106)'}}>Distanza armadio</td>
                        <td>{details.DISTANZA_BITSTREAM_NGA_VULA_FTTCab} m</td>
                    </tr>
                </table>
                <p className="techtTitle">VDSL</p>
                <table style={{border: '1px solid #dee2e6'}} className="dataTable">
                    <tr>
                        <td style={{fontWeight: 'bold', color: 'rgb(95, 106, 106)'}}>Copertura</td>
                        <td>{details.COPERTURA_BITSTREAM_NGA_VULA_FTTCab}</td>
                    </tr>
                    {setPlannedDate(details.COPERTURA_BITSTREAM_NGA_VULA_FTTCab, details.PIANIFICAZIONE_BITSTREAM_NGA_VULA_FTTCab)}
                    <tr>
                        <td style={{fontWeight: 'bold', color: 'rgb(95, 106, 106)'}}>Download</td>
                        <td>{details.VELOCITA_DOWN_BITSTREAM_NGA_VULA_FTTCab} Mb/s</td>
                    </tr>
                    <tr>
                        <td style={{fontWeight: 'bold', color: 'rgb(95, 106, 106)'}}>Upload</td>
                        <td>{details.VELOCITA_UP_BITSTREAM_NGA_VULA_FTTCab} Mb/s</td>
                    </tr>
                </table>
                <p className="techtTitle">EVDSL</p>
                <table style={{border: '1px solid #dee2e6'}} className="dataTable">
                    <tr>
                        <td style={{fontWeight: 'bold', color: 'rgb(95, 106, 106)'}}>Copertura</td>
                        <td>{details.COPERTURA_EVDSL_BITSTREAM_NGA_VULA_FTTCab}</td>
                    </tr>
                    <tr>
                        <td style={{fontWeight: 'bold', color: 'rgb(95, 106, 106)'}}>Download</td>
                        <td>{details.VELOCITA_DOWN_EVDSL_BITSTREAM_NGA_VULA_FTTCab} Mb/s</td>
                    </tr>
                    <tr>
                        <td style={{fontWeight: 'bold', color: 'rgb(95, 106, 106)'}}>Upload</td>
                        <td>{details.VELOCITA_UP_EVDSL_BITSTREAM_NGA_VULA_FTTCab} Mb/s</td>
                    </tr>
                </table>
                <p className="techtTitle">FTTH</p>
                <table className="dataTable">
                    <tr>
                        <td style={{fontWeight: 'bold', color: 'rgb(95, 106, 106)'}}>1Gbit - 2.5Gbit</td>
                        <td>{details.COPERTURA_BITSTREAM_NGA_VULA_FTTH}</td>
                    </tr>
                    {setPlannedDate(details.COPERTURA_BITSTREAM_NGA_VULA_FTTH, details.PIANIFICAZIONE_BITSTREAM_NGA_VULA_FTTH)}
                    <tr style={{border: '0'}}>
                        <td style={{border: '0'}}></td>
                    </tr>
                    <tr>
                        <td style={{fontWeight: 'bold', color: 'rgb(95, 106, 106)'}}>10Gbit</td>
                        <td>{details.COPERTURA_BITSTREAM_NGA_VULA_XGSPON}</td>
                    </tr> 
                    {setPlannedDate(details.COPERTURA_BITSTREAM_NGA_VULA_XGSPON, details.PIANIFICAZIONE_BITSTREAM_NGA_VULA_XGSPON)}                   
                </table>
                <p className="techtTitle">FIBRA DEDICATA</p>
                <table style={{border: '1px solid #dee2e6'}} className="dataTable">
                    <tr>
                        <td style={{fontWeight: 'bold', color: 'rgb(95, 106, 106)'}}>Fascia</td>
                        <td>{details.FASCIA_CIRCUITI_TERM_ETH_FIBRA_OTTICA}</td>
                    </tr>                  
                </table>
            </div>
        
    )

}

export default FibercopResult;